export default __webpack_public_path__ + "static/media/ArrowLeft.1d88fcbf.svg";